<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
        class="order-sim-cards"
        title="Simkaarten bestellen"
        :icon="deanMobileIcon"
        align-top>

      <div v-if="loading">
        <dean-spinner
            size="80"
            :full-circle="true"
        ></dean-spinner>
      </div>

      <div v-if="!loading">
        <div class="row" v-if="showOdidoService">
          <div class="small-6 medium-6 large-6 hd-6 columns">
            <dean-section-divider>Odido Voice</dean-section-divider>

            <div class="row">
              <div class="small-6 medium-6 large-6 hd-6 columns">
                  <dean-select-form-row
                      id="odido_voice_sim"
                      placeholder="Selecteer Voice SIM"
                      v-model="simCards.odido.voiceSIM"
                      :requiredField="false"
                      :clearable="true"
                      :hideLabel="false"
                      :fullWidth="true"
                      label="Voice SIM"
                      :options="simCardNumbers">
                  </dean-select-form-row>
              </div>

              <div class="small-6 medium-6 large-6 hd-6 columns">
                <dean-select-form-row
                    id="odido_voice_esim"
                    placeholder="Selecteer Voice eSIM"
                    v-model="simCards.odido.voiceESIM"
                    :requiredField="false"
                    :clearable="true"
                    :hideLabel="false"
                    :fullWidth="true"
                    :disabled="false"
                    label="Voice eSIM"
                    :options="simCardNumbers">
                </dean-select-form-row>
              </div>
            </div>

            <dean-section-divider>Odido Data</dean-section-divider>

            <div class="row">
              <div class="small-6 medium-6 large-6 hd-6 columns">
                <dean-select-form-row
                    id="odido_data_sim"
                    placeholder="Selecteer Data SIM"
                    v-model="simCards.odido.dataSIM"
                    :requiredField="false"
                    :clearable="true"
                    :hideLabel="false"
                    :fullWidth="true"
                    label="Data SIM"
                    :options="simCardNumbers">
                </dean-select-form-row>
              </div>

              <div class="small-6 medium-6 large-6 hd-6 columns">
                <dean-select-form-row
                    id="odido_data_esim"
                    placeholder="Selecteer Data eSIM"
                    v-model="simCards.odido.dataESIM"
                    :requiredField="false"
                    :clearable="true"
                    :hideLabel="false"
                    :fullWidth="true"
                    label="Data eSIM"
                    :options="simCardNumbers">
                </dean-select-form-row>
              </div>
            </div>
          </div>

          <div class="small-6 medium-6 large-6 hd-6 columns">
            <dean-section-divider>Odido Wissel</dean-section-divider>

            <div class="row">
              <div class="small-6 medium-6 large-6 hd-6 columns">
                <dean-select-form-row
                    id="odido_wissel_sim"
                    placeholder="Selecteer Wissel SIM"
                    v-model="simCards.odido.wisselSIM"
                    :requiredField="false"
                    :clearable="true"
                    :hideLabel="false"
                    :fullWidth="true"
                    label="Wissel SIM"
                    :options="simCardNumbers">
                </dean-select-form-row>
              </div>
              <div class="small-6 medium-6 large-6 hd-6 columns">
                <dean-select-form-row
                    id="odido_wissel_esim"
                    placeholder="Selecteer Wissel eSIM"
                    v-model="simCards.odido.wisselESIM"
                    :requiredField="false"
                    :clearable="true"
                    :hideLabel="false"
                    :fullWidth="true"
                    label="Wissel eSIM"
                    :options="simCardNumbers">
                </dean-select-form-row>
              </div>
            </div>

            <dean-section-divider>Odido overige</dean-section-divider>

            <div class="row">
              <div class="small-6 medium-6 large-6 hd-6 columns">
                <dean-select-form-row
                    id="odido_mb_sharing"
                    placeholder="Selecteer MB-Verdeler"
                    v-model="simCards.odido.MBSharing"
                    :requiredField="false"
                    :clearable="true"
                    :hideLabel="false"
                    :fullWidth="true"
                    label="MB-Verdeler"
                    :options="simCardNumbers">
                </dean-select-form-row>
              </div>

              <div class="small-6 medium-6 large-6 hd-6 columns">
                <dean-select-form-row
                    id="odido_duo_voice_sim"
                    placeholder="Selecteer DUO SIM"
                    v-model="simCards.odido.duoVoiceSIM"
                    :requiredField="false"
                    :clearable="true"
                    :hideLabel="false"
                    :fullWidth="true"
                    label="DUO SIM (Voice)"
                    :options="simCardNumbers">
                </dean-select-form-row>
              </div>
            </div>
          </div>
        </div>

        <div v-if="showKpnService">
          <dean-section-divider>KPN Voice and data</dean-section-divider>

          <div class="row">
            <div class="small-6 medium-6 large-6 hd-6 columns">
              <dean-select-form-row
                  id="kpn_voice_data_sim"
                  placeholder="Selecteer KPN Limited Voice and Data SIM"
                  v-model="simCards.kpn.limitedVoiceAndDataSIM"
                  :requiredField="false"
                  :clearable="true"
                  :hideLabel="false"
                  :fullWidth="true"
                  label="KPN <b>Limited</b> Voice and Data SIM"
                  :options="simCardNumbers">
              </dean-select-form-row>
            </div>

            <div class="small-6 medium-6 large-6 hd-6 columns">
              <dean-select-form-row
                  id="kpn_unlimited_voice_data_sim"
                  placeholder="Selecteer KPN Unlimited Voice and Data SIM"
                  v-model="simCards.kpn.unlimitedVoiceAndDataSIM"
                  :requiredField="false"
                  :clearable="true"
                  :hideLabel="false"
                  :fullWidth="true"
                  label="KPN <b>Unlimited</b> Voice and Data SIM"
                  :options="simCardNumbers">
              </dean-select-form-row>
            </div>
          </div>
        </div>

        <dean-section-divider class="dean-section-divider-empty"></dean-section-divider>

        <dean-button :primary="true" dialog-button @click.native="orderSimCards">
          Bestel
        </dean-button>
      </div>
    </dean-dialog>
  </div>
</template>
<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import axios from 'axios';
  import {Component} from 'vue-property-decorator';

  // DEAN COMPONENTS
  import {
    deanDialog,
    deanMobileIcon,
    deanIcon,
    deanInputField,
    deanButton,
    deanSectionDivider,
    deanFormRow,
    deanSpinner,
    saveIcon,
    warningIcon,
  } from '@deanone/dean-components';
  import {getErrorFromResponse} from "@/mixins/errorMessage";
  import DeanSelectFormRow from "@/components/deanComponents/deanSelectFormRow.vue";
  import DeanInputSelect from "@/components/deanComponents/deanInputSelect.vue";

  // interfaces
  interface OdidoSimCard {
    voiceSIM: number|null;
    voiceESIM: number|null;
    dataSIM: number|null;
    dataESIM: number|null;
    wisselSIM: number|null;
    wisselESIM: number|null;
    MBSharing: number|null;
    duoVoiceSIM: number|null;
  }

  interface KpnSimCard {
    limitedVoiceAndDataSIM: number|null;
    unlimitedVoiceAndDataSIM: number|null;
  }

  interface SimCards {
    odido: OdidoSimCard;
    kpn: KpnSimCard;
  }

  @Component({
    components: {
      DeanInputSelect,
      DeanSelectFormRow,
      deanSpinner,
      deanSectionDivider,
      deanFormRow,
      deanMobileIcon,
      deanIcon,
      saveIcon,
      deanInputField,
      deanDialog,
      deanButton,
    },
  })

  export default class OrderSimCardsWidget extends Vue {
    public loading: boolean = false;
    public deanMobileIcon: object = deanMobileIcon;
    public showOdidoService: boolean = true;
    public showKpnService: boolean = true;
    public simCards: SimCards = {
      odido: {
        dataSIM: null,
        dataESIM: null,
        voiceSIM: null,
        voiceESIM: null,
        wisselSIM: null,
        wisselESIM: null,
        MBSharing: null,
        duoVoiceSIM: null,
      },
      kpn: {
        limitedVoiceAndDataSIM: null,
        unlimitedVoiceAndDataSIM: null,
      }
    };
    public simCardNumbers: Array<number> = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

    public orderSimCards() {
      this.loading = true;

      const requestUrl = '/-/trade/api/widgets.orderSimCards';
      const requestPayload = {
        odido: this.simCards.odido,
        kpn: this.simCards.kpn,
      };

      axios
        .post(requestUrl, requestPayload)
        .then(() => {
          this.simCards = {
            odido: {
              dataSIM: null,
              dataESIM: null,
              voiceSIM: null,
              voiceESIM: null,
              wisselSIM: null,
              wisselESIM: null,
              MBSharing: null,
              duoVoiceSIM: null,
            },
            kpn: {
              limitedVoiceAndDataSIM: null,
              unlimitedVoiceAndDataSIM: null,
            }
          };

          this.$toast({
            icon: saveIcon,
            text: String(this.$t('messages.simCardsOrdered')),
            theme: 'success',
          });
        })
        .catch((error) => {
          this.loading = false;

          const errorMessage: string|null = getErrorFromResponse(
              error.response.data,
              this.$store.state.main.notification.messages.couldNotReceiveData
          )

          this.$toast({
            icon: warningIcon,
            text: errorMessage ?? '',
            theme: 'danger',
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '~@deanone/dean-components/src/scss/vars';

.dean-section-divider-empty :deep(.dean-section-divider-content) {
  min-height: 1px;
  margin-bottom: 10px;
}

:deep(p.input-label) {
  text-align: left;
  padding-left: 12px;
  padding-bottom: 5px;
}

p.input-label {
  padding-left: 10px;
  padding-bottom: 5px;
  text-align: left;
}

.dean-section-divider {
  font-size: 13pt;
  padding-top: 0;
}

.dialog :deep {
  padding: 0;
}

.dialog :deep(.dean-dialog-container) {
  width: 100%;
  height: 100%;
}

.dialog :deep(.dean-dialog-container .dean-dialog-content) {
  height: 100%;
}

</style>
